import { PageContainer, PageContainerProps } from '@oaknorth/component-core-v2';

import { MediaType } from './types';
import { useMediaType } from './useMediaType';

export function ResponsivePageContainer({ children, nav, ...rest }: Omit<PageContainerProps, 'widescreen'>) {
  const atLeastTabletWidth = useMediaType(MediaType.LAPTOP);
  return (
    <PageContainer widescreen={!atLeastTabletWidth} width="100%" nav={nav} {...rest}>
      {children}
    </PageContainer>
  );
}
